<!-- =========================================================================================
    File Name: VxCard.vue
    Description: Card Component
    Component Name: VxCard
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="vx-card" ref="card" :class="[
      { 'overflow-hidden': tempHidden },
      { 'no-shadow': noShadow },
      { 'rounded-none': noRadius },
      { 'card-border': cardBorder },
      cardClasses]" :style="cardStyles" v-on="$listeners">
      <!-- <div style="float: right; margin-right:5px!important;" v-if="saveLayout && !hasHeader"><vs-button class="ml-5 mt-2" @click="saveLayoutClicked">Salvar Layout</vs-button></div> -->
      <div class="vx-card__header" v-if="hasHeader">
        <!-- style="border-bottom: 1px solid rgba(234,243,253,.9); padding: 15px 20px;" -->

        <!-- card title -->
        <div class="vx-card__title">
          <h4 v-if="this.$props.titleHtml" :style="titleStyles" :class="titleClasses" @blur="sendBlur($event, 1)"
            :contentEditable="editTitle ? true : false" v-html="titleHtml"></h4>
          <h4 v-else-if="this.$props.title" :style="titleStyles" :class="titleClasses" @blur="sendBlur($event, 1)"
            :contentEditable="editTitle ? true : false">{{ title }}</h4>
          <h6 v-if="this.$props.subtitle" :style="subtitleStyles" :class="subtitleClasses" @blur="sendBlur($event, 2)"
            :contentEditable="editSubtitle ? true : false">{{ subtitle }}</h6>
        </div>

        <!-- card actions -->
        <div class="vx-card__actions" v-if="hasAction">
          <slot name="actions">
            <!-- v-if="(actionButtons || collapseAction || refreshContentAction || removeCardAction || btnEdit || addAction || pencilAction || trashAction || saveLayout || addNew) && !codeToggler" -->
            <div class="vx-card__action-buttons"
              >
              <feather-icon @click="addFieldClicked" icon="PlusIcon" class="ml-4 text-primary" size="2x"
                v-if="addAction" />
              <feather-icon @click="editButtonClicked" icon="Edit2Icon" class="ml-4 text-primary" v-if="pencilAction" />
              <feather-icon @click="trashButtonClicked" icon="Trash2Icon" class="ml-4 text-danger" v-if="trashAction" />
              <feather-icon @click="toggleContent" icon="ChevronUpIcon" :class="{ rotate180: !isContentCollapsed }"
                class="ml-4" v-if="actionButtons || collapseAction" />
              <!-- <feather-icon @click="refreshcard" icon="RotateCwIcon" class="ml-4" v-if="actionButtons || refreshContentAction" /> -->
              <!-- <feather-icon @click="removeCard" icon="XIcon" class="ml-4" v-if="actionButtons || removeCardAction" /> -->
              <!-- <vs-button class="ml-auto mt-2" v-if="btnEdit">Editar</vs-button> -->
            </div>
            <div class="vx-card__code-toggler sm:block hidden" v-if="codeToggler && !actionButtons">
              <feather-icon icon="CodeIcon"
                :class="{ 'border border-solid border-primary border-t-0 border-r-0 border-l-0': showCode }"
                @click="toggleCode"></feather-icon>
            </div>
          </slot>
        </div>
        <!-- <div style="float: right;" v-show="btnPrint"><vs-button style="margin-left: 100%!important;" class="mt-2" color="danger" icon-pack="feather" icon="icon-printer" @click="$router.push(`/modules/edit/${$route.params.moduleHash}${$route.params.rowHash ? '/' + $route.params.rowHash : ''}`)"> {{btnPrintLabel}}</vs-button></div> -->
        <!-- <template v-if="moduleActionButtons" v-for="(item, index) of moduleActionButtons">
          <vs-button class="mr-2" style="display: inline-block!important;" color="primary" type="filled"
            @click="triggerButtonFunction(item)" icon-pack="feather">

            <component :is="getIconComponent(item.icon)" size="15" style="margin-right: 5px!important;"
              class="custom-class" />
            {{ item.name }}
          </vs-button>
        </template> -->
        <div style="float: right; max-height: 0px!important;" v-show="btnEdit">
          <vs-button v-show="btnEdit" style="float: right!important; z-index: 9999" class="ml-auto"
            @click="$router.push(`/modules/edit/${$route.params.moduleHash}${$route.params.rowHash ? '/' + $route.params.rowHash : ''}`)">
            <component :is="getIconComponent('Edit2Icon')" size="15" style="margin-right: 5px!important;"
              class="custom-class" />
            Editar
          </vs-button>
        </div>
        <!-- <div style="float: right;" v-if="saveLayout"><vs-button class="ml-5 mt-2" @click="saveLayoutClicked">Salvar Layout</vs-button></div> -->
        <div style="display: inline-block!important; align-items: top!important;" v-if="saveLayout || addNew">
          <div style="float: right;" v-if="saveLayout"><vs-button class="ml-2" @click="saveLayoutClicked"
              :disabled="this.$props.saveLayoutDisabled" color="primary" type="filled" icon-pack="feather"
              icon="icon-save">{{
                $t('ROLES.save_layout') }}</vs-button></div>
          <div style="float: right;" v-if="addNew"><vs-button @click="addNewClicked" color="primary" type="filled"
              icon-pack="feather" icon="icon-plus">{{ $t('ROLES.add') }}</vs-button></div>
        </div>
      </div>

      <div class="vx-card__collapsible-content vs-con-loading__container" ref="content"
        :class="[{ collapsed: isContentCollapsed }, { 'overflow-hidden': tempHidden }]" :style="StyleItems">

        <!-- content with no body(no padding) -->
        <slot name="no-body"></slot>

        <!-- content inside body(with padding) -->
        <div class="vx-card__body" v-if="this.$slots.default">
          <slot></slot>
        </div>

        <!-- content with no body(no padding) -->
        <slot name="no-body-bottom"></slot>

        <div class="vx-card__footer" v-if="this.$slots.footer">
          <slot name="footer"></slot>
        </div>
      </div>

      <div class="vx-card__code-container" ref="codeContainer" v-show="this.$slots.codeContainer"
        :style="codeContainerStyles" :class="{ collapsed: !showCode }">
        <div class="code-content">
          <prism :language="codeLanguage" :key="$vs.rtl">
            <slot name="codeContainer"></slot>
          </prism>
        </div>
      </div>
    </div>
    <br>
  </div>
</template>

<script>
import Prism from 'vue-prism-component'
import _color from '@/assets/utils/color.js'
// import { Edit2Icon, PrinterIcon } from 'vue-feather-icons'
import * as FeatherIcons from 'vue-feather-icons'
import { transformIconName } from '../../helpers.js'

export default {
  name: 'vx-card',
  props: {
    moduleActionButtons: {
      default: () => [],
      type: Array
    },
    saveLayoutDisabled: {
      type: Boolean,
      default: false
    },
    editTitle: {
      type: Boolean,
      default: false
    },
    editSubtitle: {
      type: Boolean,
      default: false
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    isCollapsed: {
      type: Boolean,
      default: false
    },
    title: String,
    titleHtml: String,
    subtitle: String,
    actionButtons: {
      type: Boolean,
      default: false
    },
    actionButtonsColor: {
      type: String,
      default: 'success'
    },
    codeToggler: {
      type: Boolean,
      default: false
    },
    noShadow: {
      default: false,
      type: Boolean
    },
    noRadius: {
      default: false,
      type: Boolean
    },
    cardBorder: {
      default: false,
      type: Boolean
    },
    codeLanguage: {
      default: 'markup',
      type: String
    },
    collapseAction: {
      default: false,
      type: Boolean
    },
    refreshContentAction: {
      default: false,
      type: Boolean
    },
    removeCardAction: {
      default: false,
      type: Boolean
    },
    addAction: {
      default: '',
      type: String
    },
    pencilAction: {
      default: '',
      type: String
    },
    trashAction: {
      default: '',
      type: String
    },
    saveLayout: {
      default: false,
      type: Boolean
    },
    addNew: {
      default: false,
      type: Boolean
    },
    headerBackground: {
      default: '',
      type: String
    },
    btnEdit: {
      default: false,
      type: Boolean
    },
    btnPrint: {
      default: false,
      type: Boolean
    },
    btnPrintUrl: {
      default: '',
      type: String
    },
    btnPrintApiToken: {
      default: '',
      type: String
    },
    btnPrintMaxTimeout: {
      default: 10,
      type: Number
    },
    btnPrintLabel: {
      default: 'Imprimir',
      type: String
    },
    btnPrintData: {
      default: () => { },
      type: Object
    },
    cardBackground: {
      default: '',
      type: String
    },
    contentColor: {
      default: '',
      type: String
    },
    titleColor: {
      default: '',
      type: String
    },
    subtitleColor: {
      default: '#b8c2cc',
      type: String
    },
    triggerButtonFunction: {
      type: Function
    }
  },
  data() {
    return {
      isContentCollapsed: false,
      showCode: false,
      maxHeight: null,
      cardMaxHeight: null,
      codeContainerMaxHeight: '0px',
      tempHidden: false
    }
  },
  mounted() {
    if (this.hasAction && this.isCollapsed) {
      this.toggleContent()
    }
  },
  computed: {
    hasAction() {
      return this.$slots.actions || (this.actionButtons || this.collapseAction || this.btnEdit || this.refreshContentAction || this.removeCardAction || this.codeToggler || this.addAction || this.pencilAction || this.trashAction)
    },
    canEditData() {
      return this.canEdit
    },
    hasHeader() {
      return this.hasAction || (this.title || this.titleHtml || this.subtitle || this.saveLayout)
    },
    StyleItems() {
      return { maxHeight: this.maxHeight }
    },
    cardStyles() {
      const obj = { maxHeight: this.cardMaxHeight }
      if (!_color.isColor(this.cardBackground)) obj.background = _color.getColor(this.cardBackground)
      if (!_color.isColor(this.contentColor)) obj.color = _color.getColor(this.contentColor)
      return obj
    },
    codeContainerStyles() {
      return { maxHeight: this.codeContainerMaxHeight }
    },
    cardClasses() {
      let str = ''

      // Add bg class
      if (_color.isColor(this.cardBackground)) {
        str += ` bg-${this.cardBackground}`
      }

      // add content color
      if (_color.isColor(this.contentColor)) {
        str += ` text-${this.contentColor}`
      }

      return str.trim()
    },
    titleStyles() {
      return {
        color: _color.getColor(this.titleColor)
      }
    },
    titleClasses() {
      let str = ''

      // add content color
      if (_color.isColor(this.titleColor)) {
        str += ` text-${this.titleColor}`
      }

      return str.trim()
    },
    subtitleStyles() {
      const obj = {}
      if (!_color.isColor(this.subtitleColor)) obj.color = _color.getColor(this.subtitleColor)

      return obj
    },
    subtitleClasses() {
      let str = ''

      // add content color
      if (_color.isColor(this.subtitleColor)) {
        str += ` text-${this.subtitleColor}`
      }

      return str.trim()
    }
  },
  watch: {
    moduleActionButtons(newValue, oldValue) {
    },
  },
  methods: {
    transformIconName,
    triggerFunction(buttonData) {
      this.triggerButtonFunction(buttonData);
    },
    getIconComponent(iconName) {
      return FeatherIcons[iconName] || null
    },
    async callPrintFunction() {

      this.$vs.loading({ type: 'default' })

      let maxTimeout = this.btnPrintMaxTimeout * 1000

      setTimeout(() => {
        this.$vs.loading.close()
      }, maxTimeout)

      return new Promise(async (resolve) => {

        const controller = new AbortController()
        const id = setTimeout(() => controller.abort(), maxTimeout)

        await fetch(`${this.btnPrintUrl}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          timeout: maxTimeout,
          signal: controller.signal,
          body: JSON.stringify({
            command: 'print_row_data',
            application_token: this.$store.state.auth.app_token,
            api_token: this.btnPrintApiToken,
            module_token: this.$route.params.moduleHash,
            row_hash: this.$route.params.rowHash,
            row_data: this.btnPrintData
          })
        })
          .then(async (response) => {
            let messageColor = 'success'
            let messageIcon = 'icon-check-circle'
            if (response.status.toString().charAt(0) === '4') {
              messageColor = 'warning'
              messageIcon = 'icon-alert-circle'
            } else if (response.status.toString().charAt(0) === '5') {
              messageColor = 'danger'
              messageIcon = 'icon-alert-circle'
            }

            if (response.status === 200) {
              response.json().then(responseData => {

                this.$vs.loading.close()

                window.open(responseData.file_url)


                resolve(true)
              })
            }
          })
          .catch((e) => {
            resolve(true)
          })

        clearTimeout(id)
      })
    },
    sendBlur(event, titleType = null) {
      if (titleType !== null) {
        this.$emit('blur', { event: event, titleType })
      } else {
        this.$emit('blur', event)
      }
    },
    addFieldClicked() {
      this.$emit('addButtonClicked', this.addAction)
    },
    editButtonClicked() {
      this.$emit('editButtonClicked', this.pencilAction)
    },
    trashButtonClicked() {
      this.$emit('trashButtonClicked', this.trashAction)
    },
    saveLayoutClicked() {
      this.$emit('saveLayoutClicked')
    },
    addNewClicked() {
      this.$emit('addNewClicked')
    },
    toggleContent() {
      this.$refs.content.style.overflow = 'hidden'
      const scrollHeight = this.$refs.content.scrollHeight
      if (this.maxHeight === '1.5rem') {
        this.maxHeight = `${scrollHeight}px`
        setTimeout(() => {
          this.maxHeight = 'none'
          this.$refs.content.style.overflow = null
        }, 300)
      } else {
        this.maxHeight = `${scrollHeight}px`
        setTimeout(() => {
          this.maxHeight = '1.5rem'
          this.$refs.content.style.overflow = null
        }, 50)
      }
      this.isContentCollapsed = !this.isContentCollapsed
      this.$emit('toggleCollapse', this.isContentCollapsed)
    },
    refreshcard() {
      this.$vs.loading({
        container: this.$refs.content,
        scale: 0.5
      })
      this.tempHidden = true
      this.$emit('refresh', this)
    },
    removeRefreshAnimation(time = 100) {
      setTimeout(() => {
        this.$vs.loading.close(this.$refs.content)
        this.tempHidden = false
      }, time)
    },
    removeCard() {
      const scrollHeight = this.$refs.card.scrollHeight
      this.cardMaxHeight = `${scrollHeight}px`
      this.$el.style.overflow = 'hidden'
      setTimeout(() => {
        this.cardMaxHeight = '0px'
      }, 50)
      this.$emit('remove')
    },
    toggleCode() {
      this.tempHidden = true
      this.showCode = !this.showCode
      const scrollHeight = this.$refs.codeContainer.scrollHeight
      if (this.codeContainerMaxHeight === '0px') {
        this.codeContainerMaxHeight = `${scrollHeight}px`
        setTimeout(() => {
          this.codeContainerMaxHeight = 'none'
          this.tempHidden = false
        }, 300)
      } else {
        this.codeContainerMaxHeight = `${scrollHeight}px`
        setTimeout(() => {
          this.codeContainerMaxHeight = '0px'
          this.tempHidden = false
        }, 150)
      }
    }
  },
  components: {
    Prism,
    // Edit2Icon,
    // PrinterIcon
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxCard.scss"
</style>
